import React, { useState, useMemo } from "react";
import "../styles/MCQ.scss";

const MCQSummary = ({
  questions = [],
  current = 0,
  answers = {},
  onNavigate = () => {},
  pageType = "quiz",
  contentTitle = "",
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const parsedQuestions = useMemo(() => {
    if (!questions || questions.length === 0) return [];

    if (pageType === "content" || pageType === "active_recall_content") {
      return questions;
    }

    if (
      questions[0] &&
      typeof questions[0] === "object" &&
      "content" in questions[0]
    ) {
      try {
        return questions.flatMap((item) => {
          if (item.content) {
            let parsedContent;
            if (typeof item.content === "string") {
              try {
                parsedContent = JSON.parse(item.content);
              } catch (e) {
                try {
                  const cleaned = item.content
                    .replace(/\\"/g, '"')
                    .replace(/^"|"$/g, "");
                  parsedContent = JSON.parse(cleaned);
                } catch (innerError) {
                  console.error("Error parsing content string:", e);
                  return [];
                }
              }
            } else if (typeof item.content === "object") {
              parsedContent = item.content;
            }
            return parsedContent?.questions || [];
          }
          return [];
        });
      } catch (e) {
        console.error("Error processing nested questions:", e);
        return [];
      }
    }

    if (typeof questions[0] === "string") {
      try {
        return questions.map((q) =>
          typeof q === "string" ? JSON.parse(q) : q
        );
      } catch (e) {
        console.error("Error parsing questions:", e);
        return questions;
      }
    }
    return questions;
  }, [questions, pageType]);

  if (!parsedQuestions || parsedQuestions.length === 0) return null;

  return (
    <div className="mcq-summary-card">
      <div className="mcq-index-panel">
        {!isCollapsed && (
          <div
            className="mcq-index-grid"
            role="list"
            aria-label="Question navigator"
          >
            {parsedQuestions.map((_, i) => {
              const q = parsedQuestions[i];
              const qId = q.question_id || q.question;
              const isCurrent = i === current;
              const answer = answers[qId];

              const isAnswered =
                answer !== undefined &&
                answer !== null &&
                answer !== "" &&
                (typeof answer === "object"
                  ? answer.value !== undefined && answer.value !== ""
                  : true);

              return (
                <button
                  key={`q-${i}`}
                  type="button"
                  role="listitem"
                  className={[
                    "mcq-index-item",
                    isCurrent ? "current" : "",
                    isAnswered ? "answered" : "",
                  ].join(" ")}
                  onClick={() => onNavigate(i)}
                  aria-current={isCurrent ? "true" : undefined}
                  aria-label={`Go to question ${i + 1}${
                    isAnswered ? ", answered" : ""
                  }`}
                >
                  {i + 1}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default MCQSummary;
